import { i18n } from 'next-i18next';
import { SUPPORTED_LANGUAGES } from '@source/constants/config';
import sharedEn from '@source/lang/en.json';
import sharedId from '@source/lang/id.json';
import sharedMy from '@source/lang/my.json';
import sharedTh from '@source/lang/th.json';
import sharedJa from '@source/lang/ja.json';
import sharedZhSg from '@source/lang/zhSg.json';
import sharedMsSg from '@source/lang/msSg.json';
import sharedZhHanS from '@source/lang/zhHanS.json';
import sharedZhHanT from '@source/lang/zhHanT.json';

import aboutUsEn from '@source/pages/AboutUs/lang/en.json';
import aboutUsJa from '@source/pages/AboutUs/lang/ja.json';
import aboutUsZhHanS from '@source/pages/AboutUs/lang/zhHanS.json';
import aboutUsZhHanT from '@source/pages/AboutUs/lang/zhHanT.json';

import refurbEn from '@source/pages/Refurb/lang/en.json';
import refurbMy from '@source/pages/Refurb/lang/my.json';
import refurbZhMy from '@source/pages/Refurb/lang/zhMy.json';

import ccpoEn from '@source/pages/CarroCertified/lang/en.json';
import ccpoId from '@source/pages/CarroCertified/lang/id.json';
import ccpoMy from '@source/pages/CarroCertified/lang/my.json';
import ccpoTh from '@source/pages/CarroCertified/lang/th.json';
import ccpoJa from '@source/pages/CarroCertified/lang/ja.json';
import ccpoZhSg from '@source/pages/CarroCertified/lang/zhSg.json';
import ccpoMsSg from '@source/pages/CarroCertified/lang/msSg.json';
import ccpoZhHanS from '@source/pages/CarroCertified/lang/zhHanS.json';
import ccpoZhHanT from '@source/pages/CarroCertified/lang/zhHanT.json';

import appointmentEn from '@source/pages/Appointments/lang/en.json';
import appointmentMy from '@source/pages/Appointments/lang/my.json';
import appointmentZhSg from '@source/pages/Appointments/lang/zhSg.json';

import contactUsEn from '@source/pages/ContactUs/lang/en.json';
import contactUsId from '@source/pages/ContactUs/lang/id.json';
import contactUsMy from '@source/pages/ContactUs/lang/my.json';
import contactUsTh from '@source/pages/ContactUs/lang/th.json';
import contactUsJa from '@source/pages/ContactUs/lang/ja.json';
import contactUsZhSg from '@source/pages/ContactUs/lang/zhSg.json';
import contactUsMsSg from '@source/pages/ContactUs/lang/msSg.json';
import contactUsZhHanS from '@source/pages/ContactUs/lang/zhHanS.json';
import contactUsZhHanT from '@source/pages/ContactUs/lang/zhHanT.json';

import locateUsEn from '@source/pages/LocateUs/lang/en.json';
import locateUsId from '@source/pages/LocateUs/lang/id.json';
import locateUsMy from '@source/pages/LocateUs/lang/my.json';
import locateUsTh from '@source/pages/LocateUs/lang/th.json';
import locateUsZhSg from '@source/pages/LocateUs/lang/zhSg.json';
import locateUsMsSg from '@source/pages/LocateUs/lang/msSg.json';
import locateUsZhHanT from '@source/pages/LocateUs/lang/zhHanT.json';
import locateUsZhHanS from '@source/pages/LocateUs/lang/zhHanS.json';
import locateUsJa from '@source/pages/LocateUs/lang/ja.json';

import termsConditionsEn from '@source/pages/TermsAndConditions/lang/en.json';
import termsConditionsId from '@source/pages/TermsAndConditions/lang/id.json';
import termsConditionsMy from '@source/pages/TermsAndConditions/lang/my.json';
import termsConditionsTh from '@source/pages/TermsAndConditions/lang/th.json';
import termsConditionsZhSg from '@source/pages/TermsAndConditions/lang/zhSg.json';
import termsConditionsZhHanS from '@source/pages/TermsAndConditions/lang/zhHanS.json';
import termsConditionsZhHanT from '@source/pages/TermsAndConditions/lang/zhHanT.json';

import carroCareEn from '@source/pages/CarroCare/lang/en.json';
import carroCareMs from '@source/pages/CarroCare/lang/msSg.json';
import carroCareZhSg from '@source/pages/CarroCare/lang/zhSg.json';

import sellCarEn from '@source/pages/SellCar/lang/en.json';
import sellCarId from '@source/pages/SellCar/lang/id.json';
import sellCarMy from '@source/pages/SellCar/lang/my.json';
import sellCarTh from '@source/pages/SellCar/lang/th.json';
import sellCarJa from '@source/pages/SellCar/lang/ja.json';
import sellCarZhSg from '@source/pages/SellCar/lang/zhSg.json';
import sellCarMsSg from '@source/pages/SellCar/lang/msSg.json';
import sellCarZhHanS from '@source/pages/SellCar/lang/zhHanS.json';
import sellCarZhHanT from '@source/pages/SellCar/lang/zhHanT.json';

export enum I18nPageKey {
  ABOUT_US = 'aboutUs',
  REFURB = 'refurb',
  CCPO = 'ccpo',
  APPOINTMENT = 'appointment',
  CONTACT_US = 'contactUs',
  LOCATE_US = 'locateUs',
  TERMS_CONDITIONS = 'termsConditions',
  CARRO_CARE = 'carroCare',
  SELL_CAR = 'sellCar',
}

const i18nSharedResourceByLanguage: { [key: string]: any } = {
  [SUPPORTED_LANGUAGES.EN.code]: { shared: sharedEn },
  [SUPPORTED_LANGUAGES.ID.code]: { shared: sharedId },
  [SUPPORTED_LANGUAGES.MY.code]: { shared: sharedMy },
  [SUPPORTED_LANGUAGES.TH.code]: { shared: sharedTh },
  [SUPPORTED_LANGUAGES.JA.code]: { shared: sharedJa },
  [SUPPORTED_LANGUAGES['ZH-SG'].code]: { shared: sharedZhSg },
  [SUPPORTED_LANGUAGES['ZH-MY'].code]: { shared: sharedZhSg },
  [SUPPORTED_LANGUAGES['MS-SG'].code]: { shared: sharedMsSg },
  [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { shared: sharedZhHanS },
  [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { shared: sharedZhHanT },
};

const i18nResourceByPage: { [key: string]: any } = {
  [I18nPageKey.ABOUT_US]: {
    [SUPPORTED_LANGUAGES.EN.code]: { aboutUs: aboutUsEn },
    [SUPPORTED_LANGUAGES.JA.code]: { aboutUs: aboutUsJa },
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { aboutUs: aboutUsZhHanS },
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { aboutUs: aboutUsZhHanT },
  },
  [I18nPageKey.REFURB]: {
    [SUPPORTED_LANGUAGES.EN.code]: { refurb: refurbEn },
    [SUPPORTED_LANGUAGES.MY.code]: { refurb: refurbMy },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { refurb: refurbZhMy },
  },
  [I18nPageKey.CCPO]: {
    [SUPPORTED_LANGUAGES.EN.code]: { ccpo: ccpoEn },
    [SUPPORTED_LANGUAGES.ID.code]: { ccpo: ccpoId },
    [SUPPORTED_LANGUAGES.MY.code]: { ccpo: ccpoMy },
    [SUPPORTED_LANGUAGES.TH.code]: { ccpo: ccpoTh },
    [SUPPORTED_LANGUAGES.JA.code]: { ccpo: ccpoJa },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { ccpo: ccpoZhSg },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { ccpo: ccpoZhSg },
    [SUPPORTED_LANGUAGES['MS-SG'].code]: { ccpo: ccpoMsSg },
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { ccpo: ccpoZhHanS },
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { ccpo: ccpoZhHanT },
  },
  [I18nPageKey.APPOINTMENT]: {
    [SUPPORTED_LANGUAGES.EN.code]: { appointment: appointmentEn },
    [SUPPORTED_LANGUAGES.MY.code]: { appointment: appointmentMy },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { appointment: appointmentZhSg },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { appointment: appointmentZhSg },
  },
  [I18nPageKey.CONTACT_US]: {
    [SUPPORTED_LANGUAGES.EN.code]: { contactUs: contactUsEn },
    [SUPPORTED_LANGUAGES.ID.code]: { contactUs: contactUsId },
    [SUPPORTED_LANGUAGES.MY.code]: { contactUs: contactUsMy },
    [SUPPORTED_LANGUAGES.TH.code]: { contactUs: contactUsTh },
    [SUPPORTED_LANGUAGES.JA.code]: { contactUs: contactUsJa },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { contactUs: contactUsZhSg },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { contactUs: contactUsZhSg },
    [SUPPORTED_LANGUAGES['MS-SG'].code]: { contactUs: contactUsMsSg },
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { contactUs: contactUsZhHanS },
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { contactUs: contactUsZhHanT },
  },
  [I18nPageKey.LOCATE_US]: {
    [SUPPORTED_LANGUAGES.EN.code]: { locateUs: locateUsEn },
    [SUPPORTED_LANGUAGES.ID.code]: { locateUs: locateUsId },
    [SUPPORTED_LANGUAGES.MY.code]: { locateUs: locateUsMy },
    [SUPPORTED_LANGUAGES.TH.code]: { locateUs: locateUsTh },
    [SUPPORTED_LANGUAGES.JA.code]: { locateUs: locateUsJa },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { locateUs: locateUsZhSg },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { locateUs: locateUsZhSg },
    [SUPPORTED_LANGUAGES['MS-SG'].code]: { locateUs: locateUsMsSg },
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { locateUs: locateUsZhHanS },
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { locateUs: locateUsZhHanT },
  },
  [I18nPageKey.TERMS_CONDITIONS]: {
    [SUPPORTED_LANGUAGES.EN.code]: { termsConditions: termsConditionsEn },
    [SUPPORTED_LANGUAGES.ID.code]: { termsConditions: termsConditionsId },
    [SUPPORTED_LANGUAGES.MY.code]: { termsConditions: termsConditionsMy },
    [SUPPORTED_LANGUAGES.TH.code]: { termsConditions: termsConditionsTh },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { termsConditions: termsConditionsZhSg },
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: { termsConditions: termsConditionsZhSg },
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: { termsConditions: termsConditionsZhHanS },
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: { termsConditions: termsConditionsZhHanT },
  },
  [I18nPageKey.CARRO_CARE]: {
    [SUPPORTED_LANGUAGES.EN.code]: { carroCare: carroCareEn },
    [SUPPORTED_LANGUAGES['MS-SG'].code]: { carroCare: carroCareMs },
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: { carroCare: carroCareZhSg },
  },
  [I18nPageKey.SELL_CAR]: {
    [SUPPORTED_LANGUAGES.EN.code]: sellCarEn,
    [SUPPORTED_LANGUAGES.ID.code]: sellCarId,
    [SUPPORTED_LANGUAGES.MY.code]: sellCarMy,
    [SUPPORTED_LANGUAGES.TH.code]: sellCarTh,
    [SUPPORTED_LANGUAGES.JA.code]: sellCarJa,
    [SUPPORTED_LANGUAGES['ZH-SG'].code]: sellCarZhSg,
    [SUPPORTED_LANGUAGES['ZH-MY'].code]: sellCarZhSg,
    [SUPPORTED_LANGUAGES['MS-SG'].code]: sellCarMsSg,
    [SUPPORTED_LANGUAGES['ZH-HANS-HK'].code]: sellCarZhHanS,
    [SUPPORTED_LANGUAGES['ZH-HANT-HK'].code]: sellCarZhHanT,
  },
};

export const i18nAddResourceBundles = (page: string, ns = 'translation') => {
  const language = i18n?.language || SUPPORTED_LANGUAGES.EN.code;
  const pageResource = i18nResourceByPage[page || ''];

  i18n?.addResourceBundle(
    language,
    ns,
    { ...i18nSharedResourceByLanguage[language], ...{ ...(pageResource[language] || {}) } },
    true,
    true,
  );
};
